export function isObject(obj: unknown): boolean {
  if (obj === null) {
    return false;
  }

  if (typeof obj !== "object") {
    return false;
  }

  const prototype = Object.getPrototypeOf(obj);
  if (prototype === null) {
    return false;
  }

  if (prototype !== Object.prototype) {
    return false;
  }

  return true;
}
